
const {
  updateAppliedGlitchesLists,
  updateSpriteList,
} = require('./arcade-vm-hooks')
const addSoundToSprite = require('./add-sound-to-sprite.js')
const uuid = require('./uuid.js')

const globals = [
  'player 1: score',
  'player 2: score',
  'player 1: lives',
  'player 2: lives',
  'timer',
  'level #'
]

function gameStep(gamebenderVM, glitchApplications) {
  gamebenderVM.runtime.targets.forEach(target => {
    if (!target.sprite.gbSoundsAdded){
      Object.keys(gamebenderVM.gbSoundLibrary).forEach(soundName => {
        const sound = gamebenderVM.gbSoundLibrary[soundName]
        addSoundToSprite(sound, target.sprite, gamebenderVM)
      })
      target.sprite.gbSoundsAdded = true
    }
    if (!target.isStage) {
      const badGlobals = Object.values(target.variables).filter(v => globals.includes(v.name))
      badGlobals.forEach(v => {
        target.deleteVariable(v.id)
      })
    }
    if (target.threadsToClearWhenDone && target.threadsToClearWhenDone.length > 0) {
      // check if the thread is done
      target.threadsToClearWhenDone.forEach(topBlockId => {
        const threadAlive = gamebenderVM.runtime.threads.find(thread => thread.topBlock === topBlockId)
        if (!threadAlive) {
          // remove the blocks from the target
          target.blocks.deleteBlock(topBlockId)
        }
      })
    }
  })
  const stage = gamebenderVM.runtime.getTargetForStage()
  globals.forEach(globalName => {
    const global = Object.values(stage.variables).find(v => v.name === globalName)
    if (!global) {
      stage.lookupOrCreateVariable(uuid(), globalName)
    }
  })  // TODO: these probably don't need to be in `gameStep`
  updateSpriteList(gamebenderVM)
  updateAppliedGlitchesLists(gamebenderVM, glitchApplications)
  // Step the machine
  gamebenderVM.runtime._step()
  return gamebenderVM
}

module.exports = gameStep
